import { useState } from 'react';
import { useAppContext, RESET_STATE } from '../context/AppContext';
import { useUrlState } from '../utils/urlState';
import { saveDesign } from '../api/designAPI';
import Modal from 'react-modal';
import PlantShoppingList from '../components/PlantShoppingList';
import GardenShoppingList from '../components/GardenShoppingList';
import backButtonPng from '../images/ui_buttons/back_button.png';
import saveButtonPng from '../images/ui_buttons/save_button.png';
import { Paper, Grid, ScrollArea, Title, Container } from '@mantine/core';
import { MobileView, BrowserView } from 'react-device-detect';
import SummaryTwoMobile from './SummaryTwo.mobile';

const SummaryTwo = () => {
	const { navigateWithParams } = useUrlState();
	const { state, dispatch } = useAppContext();
	const {
		designName,
		zone,
		style,
		sunlight,
		windows,
		facade,
		houseSize,
		shape,
		bedSize,
		bedConfig,
		chosenPlants,
    designId,
	} = state.currentDesign;
	const [showModal, setShowModal] = useState(false);

	const handleBack = () => {
		navigateWithParams('/summary-one');
	};

	// Save Design
	const handleSaveDesign = async () => {
		try {
			await saveDesign({
				userId: state.user.id,
				designName,
				zone,
				style,
				sunlight,
				windows,
				facade,
				houseSize,
				shape,
				bedSize,
				bedConfig,
				chosenPlants,
        designId,
			});
			console.log('Design saved successfully!');
			setShowModal(true);
		} catch (error) {
			console.error('Error saving design:', error);
		}
	};

	// Navigate to Printable Summary Page
	const handleGeneratePDF = () => {
		navigateWithParams('/printable-summary');
	};

	// Close modal and reset state
	const handleCloseModal = () => {
		setShowModal(false);
		dispatch({ type: RESET_STATE });
		navigateWithParams('/');
	};

	return (
		<>
			<MobileView>
				<SummaryTwoMobile />
			</MobileView>
			<BrowserView>
				<div className='full-container'>
					<header>
						<button onClick={handleBack}>
							<img src={backButtonPng} alt='Back' className='button-image' />
						</button>
						<h1>Summary</h1>
						<button onClick={handleSaveDesign}>
							<img src={saveButtonPng} alt='Save' className='button-image' />
						</button>
					</header>
					<h2>Your Shopping List</h2>
					<Container size="xl" px="md">
						<Paper shadow="sm" p="md">
							<ScrollArea h={600} type="auto" offsetScrollbars>
								<Grid gutter="xl" style={{ minWidth: 0 }}>
									<Grid.Col span={{ base: 12, sm: 12, md: 7 }} style={{ minWidth: 0 }}>
										<Paper p="md" withBorder style={{ minWidth: 0, overflow: 'hidden' }}>
											<Title order={3} mb="md">Your Chosen Plants</Title>
											<div style={{ overflowX: 'auto' }}>
												<PlantShoppingList plants={chosenPlants} />
											</div>
										</Paper>
									</Grid.Col>
									<Grid.Col span={{ base: 12, sm: 12, md: 5 }} style={{ minWidth: 0 }}>
										<Paper p="md" withBorder style={{ minWidth: 0, overflow: 'hidden' }}>
											<Title order={3} mb="md">Additional Recommended Materials</Title>
											<div style={{ overflowX: 'auto' }}>
												<GardenShoppingList />
											</div>
										</Paper>
									</Grid.Col>
								</Grid>
							</ScrollArea>
						</Paper>
					</Container>

					{/* Modal Confirmation */}
					{showModal && (
						<Modal
							className='modal-container'
							isOpen={showModal}
							onRequestClose={() => setShowModal(false)}
							contentLabel='Design Saved! Print?'>
							<h2>Your garden design has been saved!</h2>
							<h3>Would you like to print a summary?</h3>
							<div className='modal-buttons-container'>
								<button onClick={handleGeneratePDF} className='modal-print-button'>
									Print
								</button>
								<button onClick={handleCloseModal} className='modal-skip-button'>
									Skip
								</button>
							</div>
						</Modal>
					)}
				</div>
			</BrowserView>
		</>
	);
};

export default SummaryTwo;
